// @ core
const apiURLBuilder = require('core/apiURLBuilder');
// @ utilities
const { APIGet } = require('utilities/APIRequestHelper');
// @ constants
const actionTypes = require('constants/actionTypes');
const {
    FUNDS_ABLE_TO_BE_HIRED_FILTER,
    PLANS_ABLE_TO_BE_HIRED_FILTER,
    BROKER_INVESTMENT_FUNDS_PRODUCT_URL_PARAMETER,
    BROKER_INVESTMENT_PLANS_PRODUCT_URL_PARAMETER,
    BROKER_PLANS_PRODUCT_URL_PARAMETER
} = require('constants/index');

function requestMostPopularOfMonthRequest() {
    return {
        type: actionTypes.BROKER_MOST_POPULAR_OF_MONTH_REQUEST
    };
}

function requestMostPopularOfMonthSuccess(funds, plans) {
    return {
        type: actionTypes.BROKER_MOST_POPULAR_OF_MONTH_SUCCESS,
        payload: {
            data: {
                funds: funds.rows || [],
                plans: plans.rows || []
            }
        }
    };
}

function getRentabilityLastYearOfPlansSuccess(plans) {
    return {
        type: actionTypes.BROKER_GET_RENTABILITY_LAST_YEAR_PLANS_SUCCESS,
        payload: {
            plans: plans
        }
    };
}

function getRentabilityLastYearOfFundsSuccess(funds) {
    return {
        type: actionTypes.BROKER_GET_RENTABILITY_LAST_YEAR_FUNDS_SUCCESS,
        payload: {
            funds: funds
        }
    };
}

function requestMostPopularOfMonthFailure(response) {
    return {
        type: actionTypes.BROKER_MOST_POPULAR_OF_MONTH_FAILURE,
        payload: {
            error: response
        }
    };
}

const getRentabilityLastYearOfProducts = (productsSecIds, type) => (dispatch) => {
    const typeId = type === 'funds'
        ? BROKER_INVESTMENT_FUNDS_PRODUCT_URL_PARAMETER
        : BROKER_INVESTMENT_PLANS_PRODUCT_URL_PARAMETER;
    const requestData = {
            query: {
                viewId: 'fullNew',
                LanguageId: 'es-ES',
                responseViewFormat: 'json',
                productsIds: productsSecIds,
            }
    }
    return APIGet(dispatch, apiURLBuilder.getURL('brokerGetMorningStarProductsSecurityDetails', {type:typeId}), requestData)
        .then( response => {
            if (type === 'plans') {
                dispatch(getRentabilityLastYearOfPlansSuccess(response));
            }
            else if (type === 'funds') {
                dispatch(getRentabilityLastYearOfFundsSuccess(response));
            }
        })
        .catch(error => dispatch(requestMostPopularOfMonthFailure(error)));
};

const requestMostPopularOfMonth = () => (dispatch, getState) => {
    const immBrokerMostPopularOfMonth = getState().brokerMostPopularOfMonth;
    // const hasPulses = immMarketsPulses.get('byOrder').size > 0;
    // const hasPulseById = !!immMarketsPulses.getIn(['byId', params.id]);

    if (
        immBrokerMostPopularOfMonth.get('fetchSuccess') ||
        immBrokerMostPopularOfMonth.get('isLoading')
    ) {
        return Promise.resolve();
    }

    dispatch(requestMostPopularOfMonthRequest());

    const paramsFunds = {
        query: {
            filters: FUNDS_ABLE_TO_BE_HIRED_FILTER
        }
    };

    const paramsPlans = {
        query: {
            filters: PLANS_ABLE_TO_BE_HIRED_FILTER
        }
    };

    //This endpoints are fully encoded-hardcoded in base.json since the serivce provider does not take
    //'%2B' as a functional equivalent to '+' and the framework does encode the parameters by default.
    const fundsPromise = APIGet({
        dispatch,
        endpoint: 'brokerGetMostPopularFundsPlans',
        url: apiURLBuilder.getURL('brokerGetMostPopularFunds', {type: BROKER_INVESTMENT_FUNDS_PRODUCT_URL_PARAMETER}),
        params: paramsFunds
    })

    const plansPromise = APIGet({
        dispatch,
        endpoint: 'brokerAdvancedSearch',
        url: apiURLBuilder.getURL('brokerGetMostPopularPlans', {type: BROKER_PLANS_PRODUCT_URL_PARAMETER}),
        params: paramsPlans
    })

    const plansSecId = [];
    const fundsSecId = [];
    return Promise.all([fundsPromise, plansPromise])
        .then(response => {
            dispatch(requestMostPopularOfMonthSuccess(response[0], response[1]));
            response[0].rows.forEach(fund => {
                fundsSecId.push(fund.SecId);
            });
            response[1].rows.forEach(plans => {
                plansSecId.push(plans.SecId);
            });
        })
        .then(() => {
            dispatch(getRentabilityLastYearOfProducts(fundsSecId.join('|'),'funds'));
            dispatch(getRentabilityLastYearOfProducts(plansSecId.join('|'),'plans'));
        })
        .catch(error => dispatch(requestMostPopularOfMonthFailure(error)));
};

module.exports = {
    requestMostPopularOfMonth
};
